import { cdnApiClient } from './cdnApiClient';
import { cdnApiPath } from './cdnApiPaths';

// Legacy flat lookup -- kept for internal/admin use, replaced by the org-scoped resolvers below.
export const getExperienceBySlug = (slug) => cdnApiClient.request(cdnApiPath(`experiences/${slug}`));

export const getOrganizationExperiences = (organizationId) => cdnApiClient.request(
  cdnApiPath(`organizations/${organizationId}/experiences`),
);

// Resolves a group's default Experience -- backs /map/:orgSlug.
export const getDefaultExperienceForOrg = (orgSlug) => cdnApiClient.request(
  cdnApiPath(`organizations/by-slug/${orgSlug}/experiences/default`),
);

// Resolves a named Experience scoped to its group -- backs /map/:orgSlug/:experienceSlug.
export const getNamedExperienceForOrg = (orgSlug, experienceSlug) => cdnApiClient.request(
  cdnApiPath(`organizations/by-slug/${orgSlug}/experiences/${experienceSlug}`),
);
